import { getRoot, Instance, types } from 'mobx-state-tree';
import { SupportedMapLayers, VIType } from './enums';
import { luxonUserLocale } from '@farmai-shared/LFUtils';
import { DateTimeType } from './DateTimeUtility';
import { IRootStoreAny } from './rootUtilType';
const ExtraInfoModel = types.model({
  maskedPercentage: types.maybeNull(types.number),
  isComposite: types.optional(types.boolean, false),
  crs: types.maybeNull(types.string)
});
export const AbstractMapLayerBase = types.model({
  id: types.identifier,
  datetime: DateTimeType,
  cropzone_id: types.string,
  type: types.frozen<SupportedMapLayers | VIType>(),
  extra_info: types.optional(ExtraInfoModel, {})
}).views(self => ({
  get root() {
    return getRoot<IRootStoreAny>(self);
  }
})).views(self => ({
  get datetimeZ() {
    const cropzone = self.root.uiStore.currentOrganization.cropzones.get(self.cropzone_id);
    const lang = self.root.userStore.user.settings.lang;
    return cropzone && self.datetime.setZone(cropzone.timezone).reconfigure({
      outputCalendar: lang === 'th' ? 'Buddhist' : 'gregory'
    }).setLocale(luxonUserLocale(lang));
  },
  get crs() {
    return self.extra_info?.crs;
  },
  get cloudPercentage() {
    return self.extra_info?.maskedPercentage || undefined;
  }
}));
export type IMapLayer = Instance<typeof AbstractMapLayerBase>;